var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress_inner"},[_c('div',{staticClass:"progress_inner__step"},[_c('label',{attrs:{"for":"step-1"}})]),_vm._v(" "),_c('div',{staticClass:"progress_inner__bar"}),_vm._v(" "),_c('div',{staticClass:"progress_inner__bar--set"})])])
}]

export { render, staticRenderFns }